module.exports = __webpack_public_path__ + "static/media/Incorrect inclination of the tooth9.b30aad87.png";